<template>
    <be-form-group v-bind="widgetProps">
        <be-loading :active="!options">
            <vue-multiselect
                :searchable="searchable"
                :multiple="multiple"
                :close-on-select="true"
                :clear-on-select="true"
                :show-no-options="false"
                :disabled="disabled"

                tag-placeholder=""
                select-label=""
                selected-label=""
                deselect-label=""
                placeholder=""

                :options="options || [{ value: '', label: 'Lade Optionen …' }]"
                track-by="value"
                label="label"
                :value="mappedValue"

                @input="handleInput"
            >
                <span slot="noResult">Keine Option gefunden.</span>

                <template slot="caret" slot-scope="{ toggle }">
                    <div @mousedown.prevent.stop="toggle()" class="multiselect__select">
                        <i class="mdi mdi-chevron-down"></i>
                    </div>
                </template>
            </vue-multiselect>
        </be-loading>
    </be-form-group>
</template>

<script>
    import VueMultiselect from 'vue-multiselect';
    import widget from '../../mixins/widget';

    import 'vue-multiselect/dist/vue-multiselect.min.css';

    export default {
        mixins: [widget],
        components: { VueMultiselect },

        props: {
            options: Array,
            multiple: {
                type: Boolean,
                default: false,
            },
            searchable: {
                type: Boolean,
                default: true,
            },
        },

        computed: {
            mappedValue() {
                if (!this.value || !this.options) {
                    return this.value;
                }

                if (this.multiple) {
                    return this.options.filter(o => this.value.includes(o.value));
                }

                return this.options.find(o => o.value === this.value);
            },
        },

        methods: {
            handleInput(v) {
                if (this.multiple) {
                    this.$emit('input', v.map(vv => vv.value));
                    return;
                }

                this.$emit('input', v.value);
            },
        },
    };
</script>

<style lang="scss">
    @import "../../assets/styles/multiselect";
</style>
